/* eslint-disable jsx-a11y/media-has-caption */
import * as React from 'react';
import cx from 'classnames';
import { ClassValue } from 'classnames/types';

import styles from './HeroMedia.scss';

interface IProps {
  heroSrc: string;
  isVideo: boolean;
  className?: ClassValue;
}

export const HeroMedia: React.FC<IProps> = React.memo((props) => {
  const {
    heroSrc,
    isVideo,
    className,
  } = props;

  const videoRef = React.useRef<HTMLVideoElement>(null);

  React.useEffect(() => {
    if (isVideo && videoRef.current) {
      const video = videoRef.current;

      // iOS-specific fix: Force load first frame
      const handleLoadedMetadata = () => {
        // Small delay to ensure metadata is fully loaded
        setTimeout(() => {
          video.currentTime = 0.001; // Seek to very beginning to trigger frame load
        }, 100);
      };

      video.addEventListener('loadedmetadata', handleLoadedMetadata);

      return () => {
        video.removeEventListener('loadedmetadata', handleLoadedMetadata);
      };
    }
  }, [isVideo, heroSrc]);

  return (
    <div className={cx(styles.HeroImage, className)}>
      {
        isVideo
          ? (
            <video
              ref={videoRef}
              src={heroSrc}
              className={styles.video}
              controls
              preload="metadata"
              playsInline
            />
          )
          : (
            <img src={heroSrc} className={styles.image} />
          )
      }
    </div>
  );
});

HeroMedia.displayName = 'QuickTemplateHeroImage';
